import { CgArrowTopLeft, CgArrowBottomRight } from "react-icons/cg";
const TrendingCoins = [
  {
    id: 1,
    name: "BTC/USD",
    price: "$18 928.15",
    backgroundColor: "rgb(243, 198, 247)",
    icon: <CgArrowTopLeft />,
  },
  {
    id: 2,
    name: "ETH/USD",
    price: "$591.8874",
    backgroundColor: "rgb(198, 244, 247)",
    icon: <CgArrowTopLeft />,
  },
  {
    id: 3,
    name: "XRP/USD",
    price: "$0.61688",
    backgroundColor: "rgb(181, 170, 250)",
    icon: <CgArrowTopLeft />,
  },
  {
    id: 4,
    name: "Litecoin/USD",
    price: "$87.9917",
    backgroundColor: "rgb(247, 234, 198)",
    icon: <CgArrowBottomRight />,
  },
];
export default TrendingCoins;
